import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/tokens/doubloon.png")